// EventIcons.js - Updated to allow clicks to pass through to parent event
import React from 'react';

// Updated icon container styles with pointer-events: none
const iconStyles = {
  container: {
    position: 'absolute',
    bottom: '2px',
    left: '2px',
    width: '16px',
    height: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '50%',
    zIndex: 5,
    pointerEvents: 'none' // This makes the icon ignore mouse events
  },
  icon: {
    width: '12px',
    height: '12px',
    display: 'block'
  }
};

// Using your existing icons
const EventIcon = ({ type }) => {
  // Get icon URL based on event type
  const getIconUrl = () => {
    switch(parseInt(type)) {
      case 1: return '/smallicons/important_car_small.png';
      case 2: return '/smallicons/important_people_small.png';
      case 3: return '/smallicons/important_others_small.png';
      case 4: return '/smallicons/urgent_car_small.png';
      case 5: return '/smallicons/urgent_people_small.png';
      case 6: return '/smallicons/urgent_others_small.png';
      default: return '/smallicons/important_others_small.png';
    }
  };

  return (
    <div style={iconStyles.container}>
      <img 
        src={getIconUrl()} 
        alt={`Event type ${type}`}
        style={iconStyles.icon}
      />
    </div>
  );
};

export default EventIcon;